import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: { offset: -90 } });
    let frame;
    const raf = (time) => { lenis.raf(time); frame = requestAnimationFrame(raf); };
    frame = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(frame); lenis.destroy(); window.__lenis = null; };
  }, []);
}
